import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

function readUserInfo() {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || '{}')
  } catch (e) {
    return {}
  }
}

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: readUserInfo(),
    /** 当前侧边栏行业上下文（超管=当前选中门店；商户=绑定门店） */
    shopContext: {
      industry: 'barber',
      shopId: null,
      shopName: '',
      adminMenuKeys: [],
    },
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, info) {
      state.userInfo = { ...info }
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    },
    SET_ACTIVE_SHOP(state, shopId) {
      state.userInfo = { ...state.userInfo, activeShopId: shopId }
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
      if (shopId != null) localStorage.setItem('activeShopId', String(shopId))
    },
    SET_SHOP_CONTEXT(state, payload) {
      state.shopContext = {
        industry: payload.industry || 'other',
        shopId: payload.shopId != null ? payload.shopId : null,
        shopName: payload.shopName || '',
        adminMenuKeys: Array.isArray(payload.adminMenuKeys) ? payload.adminMenuKeys : [],
      }
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = {}
      state.shopContext = { industry: 'barber', shopId: null, shopName: '', adminMenuKeys: [] }
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('activeShopId')
    },
  },
  actions: {
    logout({ commit }) {
      commit('LOGOUT')
    },
  },
})
